import { subDays } from "date-fns";
//const subDays = () => null;

export const dateNow = () => {
  const now = new Date();

  // Extraer componentes de la fecha
  const year = now.getFullYear(); // Año actual
  const month = String(now.getMonth() + 1).padStart(2, '0'); // Mes en formato 2 dígitos
  const day = String(now.getDate()).padStart(2, '0'); // Día en formato 2 dígitos

  return `${year}-${month}-${day}`;
};

export const subtractDate = (days = 30) => {
  const date = subDays(new Date(), days);

  return date;
};
